import {orgBlockedUsersPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

type BlockUserFromOrganizationInput = {
  closeContent: boolean
  contentId: string
  duration: string
  hiddenReason: string | undefined
  navigationSource?: string
  note?: string
  organizationLogin: string
  notifyBlockedUser: boolean
  shouldHideComment: boolean
  userLogin: string
}

export async function blockUserFromOrganization({
  input: {
    closeContent,
    contentId,
    duration,
    hiddenReason,
    navigationSource,
    note,
    organizationLogin,
    notifyBlockedUser,
    shouldHideComment,
    userLogin,
  },
  onError,
  onCompleted,
}: {
  input: BlockUserFromOrganizationInput
  onError?: (error: Error) => void
  onCompleted?: () => void
}) {
  const formData = new FormData()

  formData.append('duration', duration)
  formData.append('content_id', contentId)
  formData.append('login', userLogin)
  if (navigationSource) formData.append('navigation_source', navigationSource)

  if (shouldHideComment) formData.append('hide_comments', 'on')
  if (hiddenReason) formData.append('hidden_reason', hiddenReason)
  if (note) formData.append('note', note)
  if (notifyBlockedUser) formData.append('send_notification', 'on')
  if (closeContent) formData.append('close_content', '1')

  try {
    const response = await verifiedFetch(orgBlockedUsersPath({owner: organizationLogin}), {
      method: 'POST',
      body: formData,
      redirect: 'manual',
    })

    if (!response.ok && response.type !== 'opaqueredirect') {
      throw new Error('Failed to block user from organization')
    }

    onCompleted?.()
  } catch (error) {
    onError?.(error instanceof Error ? error : new Error('Failed to block user from organization'))
  }
}
